export function useStripeCallback(): ((url: string) => Promise<boolean>) | undefined {
  return undefined;
}
